import { css, cx } from '@eti/styles';
import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = shouldCenter => css`
  border-top: 1px solid #d9d9d9;
  padding: 1rem;
  text-align: ${shouldCenter ? 'center' : 'inherit'};

  & :first-child {
    border-top: 0;
  }
`;
const titleStyles = css`
  font-size: 1.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const subTitleStyles = css`
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const ProductCardBlock = _ref => {
  let {
    shouldCenter,
    children,
    className,
    subTitle,
    title
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cx(wrapperStyles(shouldCenter), 'ProductCardBlock', className),
    children: [title && /*#__PURE__*/_jsx("h2", {
      className: cx(titleStyles, 'ProductCardBlock-title'),
      children: title
    }), subTitle && /*#__PURE__*/_jsx("h3", {
      className: cx(subTitleStyles, 'ProductCardBlock-subTitle'),
      children: subTitle
    }), /*#__PURE__*/_jsx("div", {
      className: "ProductCardBlock-content",
      children: children
    })]
  });
};
ProductCardBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  shouldCenter: PropTypes.bool,
  subTitle: PropTypes.string,
  title: PropTypes.string
};
export default ProductCardBlock;